import { type ReactNode, createContext, useContext } from 'react';

import { isClientHydrated } from '#/rendering/state/renderingState';

type SsrApiDataContextValue = Partial<Record<string, unknown>>;

const SsrApiDataContext = createContext<SsrApiDataContextValue>({});

export function SsrApiDataContextProvider(props: {
  children: ReactNode;
  value: SsrApiDataContextValue;
}) {
  const { children, value } = props;

  return (
    <SsrApiDataContext value={isClientHydrated() ? {} : value}>
      {children}
    </SsrApiDataContext>
  );
}

export function useSsrApiDataContext() {
  return useContext(SsrApiDataContext);
}
